<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title1"><a id="page_iii"></a>THE</h1>
<h1 class="title2">DAWN</h1>
<h1 class="title1a">OF</h1>
<h1 class="title2">AVIATION</h1>
<p class="subtitle1">THE PIVOTAL ROLE OF SUSSEX, PEOPLE AND PLACES</p>
<p class="subtitle2">IN THE DEVELOPMENT OF FLIGHT</p>
<p class="author">JOSH SPOOR</p>
<p class="author1">With compliments to Roy Brooks</p>
<div class="img_container"><img alt="images" src="images/pub.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?55412fd5